import styled, { css } from 'styled-components'

import { Segment, FlexRow } from '..'
import { MenuItemWrapperProps, StyledSegmentProps } from './types'

export const MenuItemWrapper = styled(
  ({ active, disabled, highlighted, ...rest }: MenuItemWrapperProps) => (
    <FlexRow {...rest} />
  ),
)`
  ${({ active, disabled, highlighted, theme }) => css`
    padding: 10px;
    min-height: 40px;
    border-radius: 3px;
    cursor: ${!disabled ? 'pointer' : 'default'};
    opacity: ${!disabled ? 0.7 : 0.3};
    white-space: nowrap;
    background: ${active ? theme.colors.lightGrey : 'none'};

    span {
      font-weight: ${active || highlighted ? 400 : 300};
    }

    :hover {
      background: ${!disabled ? theme.colors.lightGrey : 'initial'};
    }
  `}
`

export const StyledSegment = styled(({ menuTitle, maxHeight, ...rest }) => (
  <Segment {...rest} />
))<StyledSegmentProps>`
  &&& {
    padding: 10px;
    margin: -1em;
    min-width: 200px;
    max-height: ${({ maxHeight }) => (maxHeight ? maxHeight : 'none')};
    overflow-y: auto;
    z-index: 10;
    margin-top: ${({ menuTitle }) =>
      !menuTitle ? '-.8em !important' : 'initial'};

    > div {
      display: block;
    }

    :last-child {
      margin-bottom: -1em;
    }
  }
`

export const MenuTitle = styled.div`
  margin: 0 0.5em;
  color: #797979;
`
